import { LocalizedText, Form } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { createUpdateValueObject } from '@mews-commander/utils';
import { useUpdateCurrentUserMutation } from '../../../queries/useUpdateCurrentUserMutation';
import { PreferencesSettings } from './PreferencesSettings';
import { LanguageAndRegionSettings } from './LanguageAndRegionSettings';
import { PreferencesFormProps, PreferencesFormValues } from './types';

export const PreferencesForm = ({ defaultValues, profiles }: PreferencesFormProps) => {
    const { isPending, mutate } = useUpdateCurrentUserMutation();
    const handleSubmit = (values: PreferencesFormValues) => {
        const updatedValues = createUpdateValueObject({ ...defaultValues }, { ...values });

        if (Object.keys(updatedValues).length > 0) {
            mutate(updatedValues);
        }
    };

    return (
        <Form defaultValues={defaultValues} onSubmit={handleSubmit} shouldFocusError>
            <Stack vertical spacing="500">
                <LanguageAndRegionSettings />

                <PreferencesSettings profiles={profiles} />

                <Stack alignment="end">
                    <Button variant="primary" type="submit" loading={isPending}>
                        <LocalizedText textKey={TextKey.Save} />
                    </Button>
                </Stack>
            </Stack>
        </Form>
    );
};
